module.exports = __webpack_public_path__ + "assets/icon-journey-csat.6c70cf4b.svg";